<app-layout>
  <div class="projects-container">
    <div class="projects-header">
      <div class="header-titles">
        <h1>Your Projects</h1>
        <p>Switch between your active projects or create a new dedicated project.</p>
      </div>
      <button mat-flat-button color="primary" class="create-btn" (click)="openCreateDialog()">
        <mat-icon>add</mat-icon>
        <span>Create Project</span>
      </button>
    </div>

    <!-- Loading State -->
    <div class="loading-state" *ngIf="isLoading">
      <div class="skeleton-card" *ngFor="let item of [1, 2, 3]">
        <ngx-skeleton-loader count="4" [theme]="{ 'border-radius': '6px', height: '24px', 'margin-bottom': '12px' }"></ngx-skeleton-loader>
      </div>
    </div>

    <!-- Projects Grid -->
    <div class="projects-grid" *ngIf="!isLoading && projects.length > 0">
      <div
        class="project-card"
        *ngFor="let p of projects"
        [class.is-active]="p.id === activeProjectId"
        (click)="selectProject(p)"
      >
        <div class="card-top">
          <div class="project-icon-wrap" [class.is-owner]="p.role === 'owner'">
            <mat-icon>{{ p.role === 'owner' ? 'folder_special' : 'folder' }}</mat-icon>
          </div>
          <div class="project-meta">
            <div class="title-row">
              <h2 class="project-title">{{ p.name }}</h2>
              <div class="card-actions" *ngIf="p.role === 'owner'">
                <button
                  mat-icon-button
                  class="branding-btn"
                  (click)="openBrandingDialog(p, $event)"
                  matTooltip="Customise Support Portal Branding"
                >
                  <mat-icon>palette</mat-icon>
                </button>
                <button
                  mat-icon-button
                  class="rename-btn"
                  (click)="openRenameDialog(p, $event)"
                  matTooltip="Rename Project"
                >
                  <mat-icon>edit</mat-icon>
                </button>
                <button
                  mat-icon-button
                  class="delete-btn"
                  (click)="confirmDeleteProject(p, $event)"
                  matTooltip="Delete Empty Project"
                >
                  <mat-icon>delete_outline</mat-icon>
                </button>
              </div>
            </div>
            <div class="badges-row">
              <span class="role-badge" [ngClass]="roleBadgeClass(p.role)">{{ formatRole(p.role) }}</span>
              <span class="status-badge" [class.archived]="p.status === 'archived'">
                {{ p.status === 'archived' ? 'Archived' : 'Active' }}
              </span>
              <span class="current-badge" *ngIf="p.id === activeProjectId">Active Now</span>
            </div>
          </div>
        </div>

        <div class="card-body">
          <div class="owner-row" *ngIf="getOwnerDisplayEmail(p)">
            <mat-icon class="owner-icon">mail</mat-icon>
            <span class="owner-label">Owner:</span>
            <span class="owner-email" [matTooltip]="getOwnerDisplayEmail(p)">{{ getOwnerDisplayEmail(p) }}</span>
          </div>
          <div class="guid-row" [matTooltip]="'Click to copy project URL: ' + getProjectUrl(p.id)" (click)="copyProjectUrl(p.id, $event)">
            <mat-icon class="guid-icon">link</mat-icon>
            <span class="guid-text">{{ getProjectDisplayUrl(p.id) }}</span>
            <mat-icon class="copy-icon">content_copy</mat-icon>
          </div>
          <div class="guid-row support-link-row" [matTooltip]="'Click to copy Support Portal URL: ' + getSupportPortalUrl(p.id)" (click)="copySupportPortalUrl(p.id, $event)">
            <mat-icon class="guid-icon">volunteer_activism</mat-icon>
            <span class="guid-text">{{ getSupportPortalDisplayUrl(p.id) }}</span>
            <mat-icon class="copy-icon">content_copy</mat-icon>
          </div>
          <div class="timestamp-row" *ngIf="p.updatedAt">
            <mat-icon>history</mat-icon>
            <span>Updated {{ p.updatedAt | date:'mediumDate' }}</span>
          </div>
        </div>

        <div class="card-footer">
          <button
            mat-stroked-button
            class="launch-btn"
            [class.active-btn]="p.id === activeProjectId"
            (click)="selectProject(p)"
          >
            <mat-icon>{{ p.id === activeProjectId ? 'arrow_forward' : 'launch' }}</mat-icon>
            <span>{{ p.id === activeProjectId ? 'Current Project' : 'Switch to this Project' }}</span>
          </button>
        </div>
      </div>

      <!-- Quick Add Card -->
      <div class="project-card new-project-card" (click)="openCreateDialog()">
        <div class="new-project-inner">
          <div class="new-icon-circle">
            <mat-icon>add</mat-icon>
          </div>
          <h3>Create New Project</h3>
          <p>Spin up a clean project with dedicated backlog and sprint board.</p>
        </div>
      </div>
    </div>

    <!-- Empty State -->
    <div class="empty-state" *ngIf="!isLoading && projects.length === 0">
      <div class="empty-icon-circle">
        <mat-icon>folder_open</mat-icon>
      </div>
      <h2>No Projects Found</h2>
      <p>You don't belong to any projects yet. Create your first project to get started.</p>
      <button mat-flat-button color="primary" class="create-btn" (click)="openCreateDialog()">
        <mat-icon>add</mat-icon>
        <span>Create Primary Project</span>
      </button>
    </div>
  </div>
</app-layout>
